// src/pages/Cloud/cloudScopeConfig.js
// 雲原生頁面的「查詢範圍」設定。
// 要開放新的雲別，只需把 enabled 改成 true 並補上對應的後端 action。

export const CLOUD_SCOPE_ALL = 'all';
export const CLOUD_SCOPE_ALL_LABEL = '全部';

export const CLOUD_SCOPE_CONFIG = {
  azure: { enabled: true, label: 'Subscription', action: 'list_subscriptions', includeAll: true },
  gcp: { enabled: true, label: 'GCP 專案', action: 'list_projects', includeAll: true },
  // AWS 的 Security Hub 是逐帳戶逐 region，混帳戶統計沒有對應的官方視角，
  // 因此帳戶必選；region 則可用「全部」對應 console 的 All linked Regions。
  aws: {
    enabled: true,
    label: 'AWS 帳戶',
    action: 'list_accounts',
    includeAll: false,
    secondary: { key: 'region_scope', label: 'Region', action: 'list_regions', includeAll: true },
  },
};

const DEFAULT_SCOPE_CONFIG = { enabled: false, label: '範圍', action: null, includeAll: true };

export const getCloudScopeConfig = (platform) => CLOUD_SCOPE_CONFIG[platform] || DEFAULT_SCOPE_CONFIG;

export const isCloudScopeEnabled = (platform) => getCloudScopeConfig(platform).enabled;

/** 第二層範圍設定（目前只有 AWS 的 Region），沒有就回 null */
export const getSecondaryScopeConfig = (platform) => getCloudScopeConfig(platform).secondary || null;
